module.exports = __webpack_public_path__ + "static/media/bilieve.563efcb0.PNG";